import React, { useState, useEffect } from 'react';
import styles from './ConfigPanel.module.css';
import ProgressStats from './ProgressStats';
import ExportImport from './ExportImport';
import FeedbackForm from './FeedbackForm';

const ConfigPanel = ({ 
  materias, 
  orientacionSeleccionada, 
  cpoPuntos, 
  onImportData,
  mostrarCPOdetallado,
  toggleMostrarCPOdetallado,
  openFeedbackTab,
  setOpenFeedbackTab
}) => {
  const [activeTab, setActiveTab] = useState('progreso');

  const tabs = [
    { id: 'progreso', label: '📊 Progreso', icon: '📊' },
    { id: 'backup', label: '💾 Backup', icon: '💾' },
    { id: 'feedback', label: '💬 Feedback', icon: '💬' }
  ];

  // Efecto para abrir el tab de feedback cuando se solicita
  useEffect(() => {
    if (openFeedbackTab) {
      setActiveTab('feedback');
      setOpenFeedbackTab(false); // Reset para próximas veces
    }
  }, [openFeedbackTab, setOpenFeedbackTab]);

  return (
    <div className={styles.panel}>
      {/* Header con tabs */}
      <div className={styles.tabsHeader}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              flex: 1,
              padding: '15px 10px',
              border: 'none',
              backgroundColor: activeTab === tab.id ? 'rgba(255,255,255,0.2)' : 'transparent',
              color: 'white',
              cursor: 'pointer',
              fontSize: '0.9em',
              fontWeight: activeTab === tab.id ? 'bold' : 'normal',
              transition: 'all 0.3s ease',
              borderBottom: activeTab === tab.id ? '3px solid white' : 'none'
            }}
          >
            {tab.icon} {tab.label}
          </button>
        ))}
        
        {/* Botón cerrar */}
        <button
          onClick={toggleMostrarCPOdetallado}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            width: '32px',
            height: '32px',
            border: 'none',
            borderRadius: '50%',
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
          onMouseOut={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
          title="Cerrar panel"
        >
          ✕
        </button>
      </div>

      {/* Contenido de tabs */}
      <div className={styles.content}>
        {activeTab === 'progreso' && (
          <div style={{ padding: '20px' }}>
            <ProgressStats 
              materias={materias}
              orientacionSeleccionada={orientacionSeleccionada}
              cpoPuntos={cpoPuntos}
            />
          </div>
        )}

        {activeTab === 'backup' && (
          <div style={{ padding: '20px' }}>
            <ExportImport
              materias={materias}
              orientacionSeleccionada={orientacionSeleccionada}
              cpoPuntos={cpoPuntos}
              onImportData={onImportData}
            />
          </div>
        )}



        {activeTab === 'feedback' && (
          <div style={{ padding: '0' }}>
            <FeedbackForm />
          </div>
        )}
      </div>

      {/* Footer con tip */}
      <div className={styles.footer}>
        {activeTab === 'progreso' && '📊 Seguí tu avance en la carrera de Derecho UBA'}
        {activeTab === 'backup' && '💾 Guardá tu progreso para no perder tu información'}
        {activeTab === 'feedback' && '💬 Tu opinión nos ayuda a mejorar para todos los estudiantes'}
      </div>
    </div>
  );
};

export default ConfigPanel; 